import Keycloak from "keycloak-js";

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak("/keycloak.json");
// keycloak.init({ onLoad: "login-required" });
// keycloak.init({ flow: "implicit", checkLoginIframe: false });

export default keycloak;
